/**
 * Meilensteine im Kalender (F-25) - rein und getestet. Ein Meilenstein ist
 * ein Zwischenschritt eines Projekts mit Datum; er steht als ganztaegiger
 * Eintrag am Tag, mit Raute statt Fahne (Deadline) oder Haekchen (Aufgabe).
 */
import { addDays } from '@/lib/datetime';
import { projectPriority } from '@/domain/priority';
import type { ID, LocalDate, PriorityKey, Project } from '@/domain/types';

export interface MeilensteinItem {
  id: ID;
  projectId: ID;
  projektTitel: string;
  title: string;
  date: LocalDate;
  done: boolean;
  areaId: ID | null;
  /** Prioritaet des Projekts (D-03) - als Punkt am Eintrag. */
  priority: PriorityKey;
}

export function meilensteinItems(projects: Project[]): MeilensteinItem[] {
  return projects
    .flatMap((p) => (p.milestones ?? []).filter((m) => m.date).map((m) => ({
      id: m.id, projectId: p.id, projektTitel: p.title, title: m.title || 'Meilenstein',
      date: m.date, done: m.done, areaId: p.areaId, priority: projectPriority(p),
    })))
    .sort((a, b) => a.date.localeCompare(b.date) || a.title.localeCompare(b.title, 'de'));
}

/** Im sichtbaren Bereich `von` bis `bis`, beide einschliesslich. */
export function meilensteineZwischen(items: MeilensteinItem[], von: LocalDate, bis: LocalDate): MeilensteinItem[] {
  return items.filter((m) => m.date >= von && m.date <= bis);
}

/** Offene Meilensteine der naechsten `tage` Tage ab heute - fuer den Blick in die Zukunft. */
export function anstehendeMeilensteine(items: MeilensteinItem[], heute: LocalDate, tage: number): MeilensteinItem[] {
  return items.filter((m) => !m.done && m.date >= heute && m.date <= addDays(heute, tage));
}
